import { render } from "./TariffsPage.vue?vue&type=template&id=781c9d86&scoped=true"
import script from "./TariffsPage.vue?vue&type=script&lang=js"
export * from "./TariffsPage.vue?vue&type=script&lang=js"

import "./TariffsPage.vue?vue&type=style&index=0&id=781c9d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781c9d86"]])

export default __exports__